import { PathologyItem } from '../../Enums/PathologyItem.enum';
import { ToothSurface } from '../../../../graphql/graphql';
import { ALL_TOOTH_SURFACES } from '../../Helpers/surfaces/allToothSurfaces';

export const PATHOLOGY_ITEMS_SURFACES: Record<PathologyItem, ToothSurface[]> = {
	[PathologyItem.FRACTURE]: [],
	[PathologyItem.DECAY]: ALL_TOOTH_SURFACES,
	[PathologyItem.ROOT_DECAY]: [],
	[PathologyItem.TOOTH_WEAR]: [],
	[PathologyItem.DISCOLORATION]: [],
	[PathologyItem.APICAL]: [],
	[PathologyItem.DEVELOPMENT_DISORDER]: [],
	[PathologyItem.EROSION]: ALL_TOOTH_SURFACES,
	[PathologyItem.ATTRITION]: ALL_TOOTH_SURFACES,
	[PathologyItem.ABFRACTION]: ALL_TOOTH_SURFACES,
};
